import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { Fragment, memo, useMemo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ExpandMore } from '@mui/icons-material';
import { FormikErrors, FormikProps, FormikTouched } from 'formik';
import { LastStepVM, TextActVM } from 'civil-status/view-models/step-form';
import Form from './form';
import { noop } from 'lodash';

interface TextActProps {
  formContext: FormikProps<LastStepVM>;
  callGetTextAct?: (startCall?: boolean) => void;
  onSaveText?: (values?: TextActVM) => void;
  onlyRead?: boolean;
  disabled?: boolean;
  disabledValid?: boolean;
  isLastStepEditAct?: boolean;
  disabledEmergency?: boolean;
  isLastStepEmergency?: boolean;
}

const TextActComponent = ({
  formContext,
  callGetTextAct = noop,
  onSaveText = noop,
  onlyRead = false,
  disabledValid = false,
  isLastStepEditAct = false,
  disabledEmergency = false,
  isLastStepEmergency = false,
}: TextActProps): React.ReactElement => {
  const [open, setOpen] = useState(false);

  const values: TextActVM = useMemo(() => {
    return formContext.values?.textAct || {};
  }, [formContext.values?.textAct]);

  const onChange = useEventCallback((key: keyof TextActVM, value: TextActVM[keyof TextActVM]) => {
    formContext.setFieldValue('textAct', {
      ...values,
      [key]: value,
    });
  });

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="accordion-text-act-content"
          id="accordion-text-act-header"
          expandIcon={<ExpandMore />}
        >
          <Typography style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            Testo atto
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          {onlyRead ? (
            formContext.values.textAct || ''
          ) : (
            <Form
              // disabled={disabled}
              values={values}
              formContext={formContext}
              onChange={onChange}
              callGetTextAct={callGetTextAct}
              onSaveText={onSaveText}
              disabledValid={isLastStepEmergency ? disabledEmergency : disabledValid}
              errors={formContext.errors.textAct as FormikErrors<TextActVM>}
              touched={formContext.touched.textAct as FormikTouched<TextActVM>}
              isLastStepEditAct={isLastStepEditAct}
            />
          )}
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

TextActComponent.displayName = 'Accordion Text Act Component';

const TextAct = memo(TextActComponent);

export default TextAct;
